import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';

const BorderLinearProgress = styled(LinearProgress)(({ theme, value, level }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    // backgroundColor: theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8',
    background: level === 'High' ? 'linear-gradient(105.18deg, #FED46A 10.67%, #E73E3E 97.75%)' : level === 'Moderate' ? 'linear-gradient(103.27deg, #39B195 57.54%, #FED46A 90.53%)' : 'linear-gradient(106.05deg, #39B195 85.54%, #5FB2EC 89%)',
    boxShadow: '0px 2px 10px 0px #5B87EF66'
  },
}));

export default function LinearProgressLine({ sx, level, value = 0 }) {
  return (
    <Box sx={{ flexGrow: 1, ...sx }}>
      <BorderLinearProgress variant="determinate" level={level} value={value} />
    </Box>
  );
}